// ** MUI Imports
import { CardActions, Chip, Divider } from '@mui/material'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import CustomAvatar from 'src/@core/components/mui/avatar'

// ** Custom Components Imports
/*
  prefetch={false} a proposito.

  Medido con Lighthouse en movil contra produccion: la home descargaba en
  segundo plano los chunks de 10 herramientas (planner, totem, artifacts,
  garden, equipment, troops, beast, colossus, packs, speeds) por el prefetch
  automatico de <Link> al entrar en viewport. Eran ~130 KB transferidos y casi
  100% sin usar — 76 KB sin usar solo de planner, 36 KB de beast — compitiendo
  por CPU y red justo durante el LCP.

  Next sigue precargando al pasar el mouse por encima, asi que en escritorio la
  navegacion sigue siendo instantanea; lo que se corta es la descarga
  especulativa en movil, donde nadie hace hover y el ancho de banda se paga.
*/
import Link from 'next/link'
import Icon from 'src/@core/components/icon'

// ** Custom Var and Components
const statusProps = {
  finished: { desc: 'Finished', color: '', show: true },
  development: { desc: 'Under development', color: '#cb4a4e', textColor: 'white', show: false, icon: 'mdi:cog', iconColor: 'white'  },
  comingsoon: { desc: 'Coming soon', color: '#E8A824', textColor: 'white', show: false, icon: 'mdi:clock', iconColor: 'white' },
  /*
    El chip NEW llevaba texto blanco sobre #E8A824: 2,08:1, menos de la mitad del
    4,5:1 que pide WCAG AA. Se mantiene el ambar —es el color que marca la
    novedad— y se oscurece el texto y el icono: #1F1300 sobre ese mismo fondo da
    8,74:1.
  */
  new: { desc: 'NEW', color: '#E8A824', textColor: '#1F1300', show: true, icon: 'mdi:star', iconColor: '#1F1300' }
}

const StatusChip = props => {
  const { status } = props

  return (
    <Chip
      label={`${statusProps[status].desc}`}
      variant='filled'
      size='small'
      icon={<Icon icon={`${statusProps[status].icon}`} color={`${statusProps[status].iconColor}`}/>}
      sx={{ marginLeft: '5px', backgroundColor: statusProps[status].color, color: statusProps[status].textColor }}
    />
  )
}

const CardMenu = props => {
  // ** Vars
  const { desc, icon, color, src, subModule, text, status } = props.data

  return (
    <Card
      className='cardHeader'
      sx={{
        overflow: 'hidden',
        position: 'relative',
        borderRadius: '12px',
        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
        borderTop: '6px solid',
        borderTopColor: 'customColors.skyPalettePrimary',
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          justifyContent: 'flex-start',
          alignItems: 'center',
          paddingTop: '0.5em',
          paddingBottom: '0.5em',
          paddingLeft: '20px',
          height: '60px',
          fontWeight: '600'
        }}
      >
        <Typography
          variant='h7'
          component={statusProps[status].show ? Link : null}
          href={statusProps[status].show ? `/${text}` : '#'}
          prefetch={false}
          className='cardHeaderTitle'
          color='text.primary'
          sx={{
            fontWeight: 600,
            textDecoration: 'none',
            textAlign: 'center',
            width: 'auto',
            display: 'inline',
            textTransform: 'uppercase'
          }}
        >
          <CustomAvatar
            skin='light'
            variant='rounded'
            sx={{
              mr: 3,
              height: 34,
              width: 34,
              color: 'primary.main',
              backgroundColor: 'transparent',
              display: 'inline',
              marginRight: '0.25rem',
              verticalAlign: 'middle'
            }}
          >
            <Icon icon={icon} />
          </CustomAvatar>
          {desc}
        </Typography>
        {status !== 'finished' ? <StatusChip status={status} /> : null}
      </Box>
      <Divider />
      <CardContent sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
        <Box
          sx={{
            display: 'contents'
          }}
        >
          {subModule
            ? subModule.map(module => {
                return (
                  <Typography key={module.name} variant='caption' sx={{ mr: 1.5 }}>
                    {module.name}
                  </Typography>
                )
              })
            : null}
        </Box>
      </CardContent>
      <CardActions>
        <Button disabled={!statusProps[status].show} size='small' component={Link} href={`/${text}`} prefetch={false}>
          CHECK TOOL
        </Button>
      </CardActions>
    </Card>
  )
}

export default CardMenu
